import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../app/store';

export interface ModalState {
  isOpen: boolean;
  title: string;
  contentKey: string;
  contentPayload?: any;
  backgroundClose: boolean;
  callback: (args: any) => void;
}

const initialState: ModalState = {
  isOpen: false,
  title: '',
  contentKey: '',
  backgroundClose: true,
  contentPayload: undefined,
  callback: () => {
    return;
  },
};

export const modalSlice = createSlice({
  name: 'modal',
  initialState,
  reducers: {
    open: (
      state,
      action: PayloadAction<{
        title: string;
        contentKey: string;
        contentPayload?: any;
        backgroundClose?: boolean;
        callback?: (args: any) => void;
      }>
    ) => {
      state.title = action.payload.title;
      state.contentKey = action.payload.contentKey;
      state.contentPayload = action.payload.contentPayload;
      state.backgroundClose = action.payload.backgroundClose ?? true;
      state.isOpen = true;
      state.callback =
        action.payload.callback ??
        (() => {
          return;
        });
    },
    close: (state) => {
      state.isOpen = false;
    },
  },
});

export const selectModal = (state: RootState) => state.modal;

export const { open, close } = modalSlice.actions;

export default modalSlice.reducer;
